import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';

class PlaceOrderOperation {
}
/**
   * Factory method to map input to placeOrder gql input format
   * @param inputData
   * @returns mapped
   */ PlaceOrderOperation.placeOrderInput = ({ consents , analyticsId , paymentRequest , checkoutId , loginRedirectUrl , shouldCreateAccount , optIns , donationIntent  })=>{
    const mappedOptIns = getOptIns(optIns);
    const mappedConsents = getConsents(consents);
    return swcHelpers.objectSpread({
        checkoutId
    }, mappedConsents && mappedConsents.length ? {
        consents: mappedConsents
    } : {}, {
        payment: swcHelpers.objectSpread({
            analyticsId
        }, getPaymentDetails(paymentRequest)),
        newAccountDetails: swcHelpers.objectSpread({}, loginRedirectUrl ? {
            loginRedirectUrl
        } : {}, {
            shouldCreateAccount
        }, mappedOptIns.length ? {
            optIns: mappedOptIns
        } : {})
    }, donationIntent ? {
        donationIntent
    } : {});
};
PlaceOrderOperation.placeOrderOutput = (responseData)=>{
    let orderResult;
    const placeOrderResponse = {
        success: false,
        redirect: false
    };
    if (responseData && 'placeOrder' in responseData) {
        orderResult = responseData.placeOrder;
        if (orderResult.__typename === 'PlaceOrderMutationSuccessResponse') {
            const { paymentResponse  } = orderResult;
            switch(paymentResponse.__typename){
                case 'PlaceOrderMutationVoucherPaymentResponse':
                case 'PlaceOrderMutationEmptyPaymentResponse':
                case 'PlaceOrderMutationDefaultPaymentResponse':
                    if ([
                        Types.ResultType.AUTHORISED,
                        Types.ResultType.RECEIVED,
                        Types.ResultType.PENDING,
                        Types.ResultType.VOUCHER, 
                    ].includes(paymentResponse.resultType)) {
                        return swcHelpers.objectSpread({}, placeOrderResponse, {
                            orderDataToken: orderResult.orderDataToken,
                            success: true,
                            resultType: paymentResponse.resultType
                        });
                    }
                    break;
                case 'PlaceOrderMutationRedirectPaymentResponse':
                    return {
                        success: true,
                        redirect: true,
                        resultType: paymentResponse.resultType,
                        redirectUrl: paymentResponse.redirectUrl,
                        httpMethod: paymentResponse.httpMethod
                    };
                case 'PlaceOrderMutationQrCodePaymentResponse':
                    return swcHelpers.objectSpread({}, placeOrderResponse, {
                        orderId: orderResult.order.id,
                        orderDataToken: orderResult.orderDataToken,
                        success: true,
                        qrCodeExpiresIn: paymentResponse.qrCodeExpiresIn,
                        qrCodeUrl: paymentResponse.qrCodeUrl,
                        redirectUrl: paymentResponse.redirectUrl,
                        resultType: paymentResponse.resultType
                    });
                default:
                    return placeOrderResponse;
            }
        } else {
            if (orderResult.__typename === 'PlaceOrderMutationFailurePostOrderCreationResponse') {
                return swcHelpers.objectSpread({}, placeOrderResponse, {
                    cartHash: orderResult.newCheckoutHash,
                    cartId: orderResult.newCheckoutId,
                    status: 'Failed'
                });
            }
            if (orderResult.__typename === 'PlaceOrderMutationFailurePreOrderCreationResponse') {
                orderResult.failures.forEach((error)=>{
                    console.error(`[error]:`, error.code);
                });
                return swcHelpers.objectSpread({}, placeOrderResponse, {
                    status: 'Failed'
                });
            }
        }
    }
    return placeOrderResponse;
};
const getConsents = (consentsInput)=>{
    const consents = [];
    if (consentsInput) {
        for(const key in consentsInput){
            consents.push({
                consentName: key,
                literalText: consentsInput[key].literalText,
                uiElementType: Types.UIElementType.CHECKBOX
            });
        }
    }
    return consents;
};
const getOptIns = (optInsInput)=>{
    const optIns = [];
    if (optInsInput) {
        for(const key in optInsInput){
            optIns.push({
                id: key,
                literalText: optInsInput[key].literalText,
                value: optInsInput[key].value,
                uiType: Types.UIType.CHECKBOX
            });
        }
    }
    return optIns;
};
const getPaymentDetails = ({ paymentMethod , amount , paymentDetails , paymentServiceProvider , returnUrl  })=>{
    return swcHelpers.objectSpread({
        returnUrl,
        paymentMethod,
        psp: paymentServiceProvider,
        amount: {
            centAmount: amount.value,
            currencyCode: amount.currency
        }
    }, getPaymentData({
        paymentDetails,
        paymentMethod
    }));
};
const getPaymentData = ({ paymentDetails , paymentMethod  })=>{
    if (paymentDetails) {
        switch(paymentMethod.toUpperCase()){
            case Types.PaymentMethod.BANCONTACT_CARD:
                return {
                    bancontactCardDetails: paymentDetails
                };
            case Types.PaymentMethod.CREDITCARD:
                return {
                    cardDetails: paymentDetails
                };
            case Types.PaymentMethod.APPLE_PAY:
                return {
                    applePayDetails: paymentDetails
                };
            case Types.PaymentMethod.PAYPAL:
                return {
                    paypalDetails: paymentDetails
                };
            case Types.PaymentMethod.MBWAY:
                return {
                    mbwayDetails: paymentDetails
                };
            case Types.PaymentMethod.IDEAL:
                return {
                    idealDetails: paymentDetails
                };
            case Types.PaymentMethod.GOOGLE_PAY:
                return {
                    googlePayDetails: paymentDetails
                };
            case Types.PaymentMethod.SEPA_DIRECT_DEBIT:
                return {
                    sepaDirectDebitDetails: paymentDetails
                };
            case Types.PaymentMethod.ONEY:
                return {
                    oneyDetails: paymentDetails
                };
            case Types.PaymentMethod.FAKE:
                return {
                    fakeDetails: paymentDetails
                };
            default:
                return null;
        }
    }
    return null;
};

export { PlaceOrderOperation };
//# sourceMappingURL=place-order-operation-mapper.js.map
